import * as React from 'react';
import {useState} from 'react';

import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
import LinearProgress from '@material-ui/core/LinearProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import {ActivityImportRetryIndex} from './ActivityImportRetryIndex';
import {sessionState} from 'session/session-state.js';
import {activityImportRetryAPI} from 'api/activity-import-retry.js';
import {DateUtil} from 'utils/date-util.js';
import {ErrorUtil} from 'utils/error-util.js';

import {GlobalCss} from 'components/global-css.js';
import {ErrorMessage} from 'components/ErrorMessage.js';

const styles = {
  flexContainer: GlobalCss.flexContainer,
  leftJustifiedIitem: GlobalCss.leftJustifiedIitem,
  rightJustifiedIitem: GlobalCss.rightJustifiedIitem,
};

const ActivityImportRetryConfirm = (props) => {
  const [showProgress, setShowProgress] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const initialState = props.location.state;

  const returnAction = () => {
    const params = {
      pathname: '/activity_import_retry',
    };
    props.history.push(params);
  };

  if (!initialState) {
    returnAction();
    return <ActivityImportRetryIndex/>;
  }

  const createParams = () => {
    return {
      'accountId': sessionState.accountId(),
      'farmId': initialState.farm.data.id,
      'linkStartDate': initialState.linkStartDate,
      'notes': initialState.notes
    };
  };

  const executeApi = () => {
    const action = activityImportRetryAPI.create(createParams());

    setShowProgress(true);
    action.then((res) => {
      setShowDialog(true);
      setTimeout(() => {
        setShowProgress(false);
        returnAction();
      }, 1000);
    }).catch((error) => {
      setShowProgress(false);
      const errorMessage = ErrorUtil.generateMessage(error);
      setErrorMessage(errorMessage);
      console.error(errorMessage);
    });
  };

  return (
    <div style={{marginLeft: '20px'}}>
      <h3>以下の内容で活動量の再取込を実行しますか？</h3>

      <Box style={{marginLeft: '40px'}}>
        <ErrorMessage errorMessage={errorMessage} />
      </Box>

      <Dialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        TransitionComponent={Slide}
        aria-labelledby="notification-dialog"
      >
        <DialogTitle id="notification-dialog">登録が完了しました</DialogTitle>
      </Dialog>

      <div style={{width: 300, marginBottom: 10, marginLeft: 200}}>
        {showProgress ? <LinearProgress /> : null}
      </div>

      <div style={{marginLeft: '30px'}}>
        <ul className={props.classes.flexContainer} style={{marginBottom: 10}}>
          <li style={{width: 80, marginTop: 10}}>
            <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>牧場名:</InputLabel>
          </li>
          <li style={{paddingTop: 5}}>
            <TextField
              type="text"
              required={true}
              placeholder=""
              value={initialState.farm.data.farmName}
              disabled={true}
              margin="none"
              style={{width: 300}}
            />
          </li>
        </ul>

        <ul className={props.classes.flexContainer} style={{marginBottom: 10}}>
          <li style={{width: 80, marginTop: 10}}>
            <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>farm_id:</InputLabel>
          </li>
          <li style={{paddingTop: 5}}>
            <TextField
              type="text"
              required={true}
              placeholder=""
              value={initialState.farm.data.id}
              disabled={true}
              margin="none"
              style={{width: 300}}
            />
          </li>
        </ul>

        <ul className={props.classes.flexContainer} style={{marginBottom: 10}}>
          <li style={{width: 140, marginTop: 10}}>
            <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>利用センサー種別:</InputLabel>
          </li>
          <li style={{paddingTop: 5}}>
            <TextField
              type="text"
              required={true}
              placeholder=""
              value={initialState.farm.useSensorTypeCaption()}
              disabled={true}
              margin="none"
              style={{width: 300}}
            />
          </li>
        </ul>

        <ul className={props.classes.flexContainer} style={{marginBottom: 10}}>
          <li style={{width: 120, marginTop: 10}}>
            <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>再取込開始日:</InputLabel>
          </li>
          <li style={{paddingTop: 5}}>
            <TextField
              type="text"
              required={true}
              placeholder=""
              value={DateUtil.toW3CFormat(initialState.linkStartDate)}
              disabled={true}
              margin="none"
              style={{width: 120}}
            />
          </li>
        </ul>

        <ul className={props.classes.flexContainer}>
          <li style={{width: 50, marginTop: 10}}>
            <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>備考:</InputLabel>
          </li>
          <li style={{paddingTop: 5}}>
            <TextField
              type="text"
              value={initialState.notes}
              variant="outlined"
              disabled={true}
              margin="dense"
              fullWidth={true}
              className={props.classes.textAreaField}
              multiline
              rows={5}
              style={{width: 500}}
            />
          </li>
        </ul>

        <div style={{marginTop: '50px', marginLeft: '50px'}}>
          <ul className={props.classes.flexContainer}>
            <li style={{marginRight: '30px'}}>
              <Button style={{width: '100px'}} variant="contained" color="primary" onClick={() => executeApi()}>
                実行
              </Button>
            </li>
            <li>
              <Button variant="contained" color="secondary" onClick={() => returnAction()}>
                  キャンセル
              </Button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

ActivityImportRetryConfirm.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

const forExport = withRouter(withStyles(styles)(ActivityImportRetryConfirm));
export {forExport as ActivityImportRetryConfirm};
